var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgImage = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.143 1.5H2.857a2.83 2.83 0 0 0-2.02.855A2.95 2.95 0 0 0 0 4.417v11.666c0 .774.302 1.515.838 2.062a2.831 2.831 0 0 0 2.02.855h14.285a2.83 2.83 0 0 0 2.02-.855A2.95 2.95 0 0 0 20 16.083V4.417a2.95 2.95 0 0 0-.838-2.062 2.831 2.831 0 0 0-2.02-.855ZM13.57 4.417c.424 0 .839.128 1.19.368.353.24.628.582.79.982.162.4.205.84.122 1.264a2.203 2.203 0 0 1-.586 1.12 2.13 2.13 0 0 1-1.098.599 2.102 2.102 0 0 1-1.238-.125 2.153 2.153 0 0 1-.961-.806 2.22 2.22 0 0 1 .267-2.761c.402-.41.946-.64 1.514-.641ZM2.857 17.542c-.379 0-.742-.154-1.01-.428a1.474 1.474 0 0 1-.418-1.03V13l4.233-3.84a2.12 2.12 0 0 1 1.486-.55 2.125 2.125 0 0 1 1.452.637l2.9 2.954-5.233 5.342h-3.41Zm15.714-1.459c0 .387-.15.758-.418 1.032a1.414 1.414 0 0 1-1.01.427H8.287l5.42-5.534a2.105 2.105 0 0 1 1.375-.518 2.11 2.11 0 0 1 1.377.51l2.112 1.797v2.286Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgImage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/image.39e549eceb15f63f216faf1ea05b0f14.svg";